<div [style.flex-direction]="flexDirection" class="spinner">
    <ng-content></ng-content>

    <div *ngIf="isBusy" [style.position]="mode" [style.zIndex]="zIndex" class="overlay">
        <mat-spinner></mat-spinner>
    </div>
</div>
